import { createAsyncThunk } from "@reduxjs/toolkit"
import { addHeatmapScanApi, deleteHeatmapApi, deleteHistoryApi, editHeatmapApi, getAdminHeatmapApi, getAdminHeatmapHistoryApi, getHeatmapApi, getHeatmapGridApi, getHeatmapHistoryApi, heatmapReportApi, refreshReportApi } from "../../apis"
import { IAddHeatmapData, IDeleteHistoryData, IEditHeatmapData, IHeatmapReportData } from "../../apis/IApisInterface"
import { showSnackbar } from "../../slices/SnackbarSlice"
import { adminHeatmapComapreBusienssApi, adminHeatmapKeywordHistoryApi, adminRefreshReportApi, adminTogglePauseRefreshHeatmapApi, getAdminHeatmapGridApi, getAdminHeatmapHistoryPaginationApi, getHeatmapHistoryPaginationApi, heatmapComapreBusienssApi, heatmapKeywordHistoryApi, pinHeatmapApi, togglePauseRefreshHeatmapApi } from "../../apis/UserApis/HeatmapApi"

export const getHeatmapHistoryAction = createAsyncThunk("heatmap/history", async (_, { rejectWithValue }) => {
    try {
        const response = await getHeatmapHistoryApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap history" })
    }
})

// new history pagination action

export const getHeatmapHistoryPaginationAction = createAsyncThunk("heatmap/history-pagination", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await getHeatmapHistoryPaginationApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap history" })
    }
})

export const adminHeatmapKeywordHistoryAction = createAsyncThunk("admin-heatmap/keyword-history", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await adminHeatmapKeywordHistoryApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get admin heatmap keyword history" })
    }
})

export const heatmapKeywordHistoryAction = createAsyncThunk("heatmap/keyword-history", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await heatmapKeywordHistoryApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap keyword history" })
    }
})

export const pinHeatmapAction = createAsyncThunk("heatmap/pin-heatmap", async (payload: { heatmapId: string; pinned: boolean }, { rejectWithValue }) => {
    try {
        const response = await pinHeatmapApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not pin heatmap" })
    }
})

export const getAdminHeatmapHistoryAction = createAsyncThunk("admin-heatmap/history", async (userId: string, { rejectWithValue }) => {
    try {
        const response = await getAdminHeatmapHistoryApi({ userId })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap history" })
    }
})

export const getAdminHeatmapHistoryPaginationAction = createAsyncThunk("admin-heatmap/history-pagination", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await getAdminHeatmapHistoryPaginationApi(payload)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap history" })
    }
})

export const addHeatmapScanAction = createAsyncThunk("add/heatmap/scan", async (data: IAddHeatmapData, { rejectWithValue, dispatch }) => {
    try {
        const response = await addHeatmapScanApi(data)
        dispatch(showSnackbar({ message: response?.data?.message || "keyword added successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add keyword" });
    }
})

export const deleteHeatmapAction = createAsyncThunk("delete/heatmap", async (ids: string[], { rejectWithValue, dispatch }) => {
    try {
        const response = await deleteHeatmapApi(ids)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not delete heatmap" });
    }
})

export const heatmapReportAction = createAsyncThunk("heatmap/report", async (id: IHeatmapReportData, { rejectWithValue, dispatch }) => {
    try {
        const response = await heatmapReportApi(id)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get heatmap report" });
    }
})

export const getHeatmapAction = createAsyncThunk("get-heatmap/history", async (heatmapId: string, { rejectWithValue }) => {
    try {
        const response = await getHeatmapApi({ heatmapId })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap history" })
    }
})

export const getAdminHeatmapAction = createAsyncThunk("admin/get-heatmap", async (heatmapId: string, { rejectWithValue }) => {
    try {
        const response = await getAdminHeatmapApi({ heatmapId })
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get admin heatmap history" })
    }
})

export const deleteHistoryAction = createAsyncThunk("delete/history", async (data: IDeleteHistoryData, { rejectWithValue, dispatch }) => {
    try {
        const response = await deleteHistoryApi(data)
        dispatch(getHeatmapAction(data.heatmapId))
        dispatch(showSnackbar({ message: response?.data?.message || "History item deleted successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not delete history" });
    }
})

export const refreshReportAction = createAsyncThunk("heatmap/refresh", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await refreshReportApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message || "Refreshed date successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not refresh date" })
    }
})

export const adminRefreshReportAction = createAsyncThunk("admin-heatmap/refresh", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await adminRefreshReportApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message || "Refreshed date successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not refresh date" })
    }
})

export const editHeatmapAction = createAsyncThunk("edit/heatmap", async (data: IEditHeatmapData, { rejectWithValue, dispatch }) => {
    try {
        const response = await editHeatmapApi(data)
        dispatch(showSnackbar({ message: response?.data?.message || "Refreshed date successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not edit heatmap" })
    }
})

export const getHeatmapGridAction = createAsyncThunk("get/heatmap/grid", async (params: { lat: number | undefined, lng: number | undefined, radius: number, grid_multiplier: number }, { rejectWithValue }) => {
    try {
        const response = await getHeatmapGridApi(params)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap grid" })
    }
})

export const togglePauseRefreshHeatmapAction = createAsyncThunk("toggle/pasuse/heatmap", async (heatmapId: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await togglePauseRefreshHeatmapApi(heatmapId)
        dispatch(showSnackbar({ message: response?.data?.message || "Pause heatmap successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not pause heatmap" })
    }
})

export const adminTogglePauseRefreshHeatmapAction = createAsyncThunk("admin/pasuse/heatmap", async (heatmapId: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await adminTogglePauseRefreshHeatmapApi(heatmapId)
        dispatch(showSnackbar({ message: response?.data?.message || "Admin pause heatmap successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not admin pause heatmap" })
    }
})

export const getAdminHeatmapGridAction = createAsyncThunk("admin/get/heatmap/grid", async (params: { lat: number | undefined, lng: number | undefined, radius: number, grid_multiplier: number }, { rejectWithValue }) => {
    try {
        const response: any = await getAdminHeatmapGridApi(params)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get heatmap grid" })
    }
})

export const heatmapComapreBusienssAction = createAsyncThunk("/compare/heatmap", async (data: { reportId: string, competitorPlaceId: string, businessId: string }, { rejectWithValue, signal }) => {
    try {
        const response: any = await heatmapComapreBusienssApi(data, signal)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not compare heatmap" })
    }
})

export const adminHeatmapComapreBusienssAction = createAsyncThunk("/admin/compare", async (data: { reportId: string, competitorPlaceId: string, businessId: string }, { rejectWithValue, signal }) => {
    try {
        const response: any = await adminHeatmapComapreBusienssApi(data, signal)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not admin compare heatmap" })
    }
})